import { ProductEditPage } from "./ProductEditPage";

export function OnlineShowcaseProductEditPage() {
  return <ProductEditPage catalogMode="online-showcase" />;
}
